module.exports = __webpack_public_path__ + "img/565.70d776dc.jpg";